<template>
  <div id="aid-order-imgs">
    <div class="title" v-if="false">{{title}}</div>
    <div class="img-box">
      <img v-for="(img,idx) in imgs" :key="idx" :src="img" @click="toShow(img)" />
    </div>
    <ImageList v-if="show" :visible.sync="show" :imgs="imgs" :current="cur" />
  </div>
</template>
<script>
import ImageList from "@/components/ImageList";
export default {
  components: { ImageList },
  props: { title: String, imgs: Array },
  data() {
    return {
      show: false,
      cur: this.imgs[0]
    };
  },
  methods: {
    toShow(img) {
      this.cur = img;
      this.show = true;
    }
  }
};
</script>
 <style lang="scss" scoped>
#aid-order-imgs {
  .title {
    margin-top: 10px;
    font-size: 14px;
    color: #999;
    padding-bottom: 24px;
    border-bottom: 1px solid #dcdcdc;
  }
  .img-box {
    img {
      width: 80px;
      height: 80px;
      margin-right: 20px;
      border-radius: 4px;
      object-fit: cover;
      cursor: pointer;
      border: 1px dashed transparent;
    }
    img:hover {
      border-color: red;
    }
  }
}
</style>